// extracted by mini-css-extract-plugin
export var component = "ArticleFeaturedImage-module--component--FKlta";
export var gatsbyImageWrapper = "ArticleFeaturedImage-module--gatsby-image-wrapper--WV+tc";